import React from 'react';
import Tappable from 'react-tappable';
import { Icon } from '@shoflo-rundown/polymer.legacy';

import CuesheetColumnActions from 'flux/actions/cuesheet/CuesheetColumnActions';

/**
 * Column Header component
 */
export default React.createClass({
  displayName: 'ColumnHeader',

  render() {
    let { column } = this.props;
    let columnId = column.get('_id');

    return (
      <div>
        <div className="csr-data-cell-header clearfix">
          {column.get('title')}
          {this._getColumnHeaderIcons(columnId)}
        </div>
      </div>
    );
  },

  _getColumnHeaderIcons(columnId) {
    let hideIcon = (
        <Tappable
          onClick={(e) => {
            e.stopPropagation();
            CuesheetColumnActions.hideColumn(columnId);
          }}
        >
          <Icon size={2} name="eye-slash" />
        </Tappable>
      ),
      downIcon = (
        <Tappable
          onClick={(e) => {
            e.stopPropagation();
            CuesheetColumnActions.moveUserColumnRight(columnId);
          }}
        >
          <Icon size={2} name="arrow-circle-o-down" />
        </Tappable>
      ),
      upIcon = (
        <Tappable
          onClick={(e) => {
            e.stopPropagation();
            CuesheetColumnActions.moveUserColumnLeft(columnId);
          }}
        >
          <Icon size={2} name="arrow-circle-o-up" />
        </Tappable>
      );

    return (
      <div className="pull-right">
        {hideIcon}
        {downIcon}
        {upIcon}
      </div>
    );
  },
});
